<template>
  <div class="absolute top-0 h-full w-full">
    <img
      class="absolute top-0 h-auto"
      src="/images/wrapped/bgpage09.jpg"
      alt=""
    />
    <img class="absolute -top-1" src="/images/wrapped/gradient.png" alt="" />
    <img
      class="absolute left-4 top-8 h-auto max-h-[21px] w-auto max-w-[21px]"
      src="/images/wrapped/ddccircularlogo.png"
      alt=""
    />
    <div class="absolute top-0 h-1/2 w-full">
      <img
        class="absolute w-full object-cover"
        src="/images/wrapped/bgpage10top.png"
        alt=""
      />
    </div>
    <div class="absolute top-1/2 h-1/2 w-full">
      <img
        class="absolute w-full object-cover"
        src="/images/wrapped/bgpage10bottom.png"
        alt=""
      />
    </div>
    <img class="absolute top-0" src="/images/wrapped/rayvector.png" alt="" />
    <div class="absolute bottom-0 h-full w-full bg-[#FFE617] opacity-40"></div>
    <img
      class="absolute left-4 top-8 h-auto max-h-[21px] w-auto max-w-[21px]"
      src="/images/wrapped/ddccircularlogo.png"
      alt=""
    />
    <div
      class="absolute top-[40%] flex w-full flex-col items-center justify-center"
    >
      <WrappedShadowContainer
        class="relative w-[320px] bg-gradient-to-b from-white to-[#FFE617] px-2 py-4 text-center text-[26px] leading-none"
      >
        <img
          class="absolute -left-4 -top-4 h-[50%] max-h-[34px] max-w-[34px]"
          src="/images/wrapped/pencil.png"
          alt=""
        />
        <WrappedTextContainer class="text-white">
          <span> helping kids like </span>
          <span class="text-[#FFE617]"> daraksha</span>
          <span>, </span>
          <span> who is now </span>
          <span class="text-[#FFE617]"> pursuing </span>
          <span> engineering </span>
          <span> at </span>
          <span class="text-[#FFE617]"> bbd university </span>
        </WrappedTextContainer>

        <img
          class="absolute -bottom-4 -right-4 mt-auto h-[50%] max-h-[36px] max-w-[36px]"
          src="/images/wrapped/book.png"
          alt=""
        />
      </WrappedShadowContainer>
    </div>
    <img
      class="absolute bottom-0"
      src="/images/wrapped/bgpage10gradientbottom.png"
      alt=""
    />
    <div
      class="absolute bottom-4 flex h-[30px] w-full items-center justify-center"
    >
      <div class="relative mr-1">
        <img
          class="relative h-auto max-h-[35px] w-auto max-w-[35px]"
          src="/images/wrapped/logo.png"
          alt=""
        />
      </div>

      <div class="relative mx-2 h-[15px] w-[1px] bg-white"></div>
      <img
        class="max-h-[40px] max-w-[183px]"
        src="/images/wrapped/sarthak.png"
        alt=""
      />
    </div>
  </div>
</template>
